import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import Toolbar from '@material-ui/core/Toolbar';

import EditIcon from '@material-ui/icons/DeleteForever';
import DeleteIcon from '@material-ui/icons/Edit';
import AddCircleIcon from '@material-ui/icons/AddCircle';


import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';


class EnhancedTableToolbar extends React.Component {

  static propTypes = {
    selected: PropTypes.any,
    data: PropTypes.any,
    handleEditClick: PropTypes.func.required,
    handleDeleteClick: PropTypes.func.required,
    handleCreateClick: PropTypes.func.required,
    renderCreateButton: PropTypes.any,
  };

  constructor(props) {

    super(props);
    this.state = {};

  }

  handleCreateClick = () => {

    this.props.handleCreateClick(this.props.selected[0]);

  }

  handleEditClick = () => {

    if (this.props.selected.length > 0) this.props.handleEditClick(this.props.selected[0]);

  }

  handleDeleteClick = () => {

    if (this.props.selected.length > 0) this.props.handleDeleteClick(this.props.selected[0]);

  }

  render() {

    return (
      <Toolbar
        className={this.props.selected.length > 0 ? 'highlight' : 'hide'}
      >
        <div>
          <div className="toolbar-message">
            {
              this.props.selected.length > 0

              && `${this.props.selected.length} registros selecionados`

            }
          </div>
          <div className="toolbar-actions">
            {
              this.props.selected.length > 0 ? (
                <div>

                  <Tooltip title={I18n.t('button.delete')}>
                    <IconButton aria-label="Delete" onClick={this.handleDeleteClick.bind(this)}>
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={I18n.t('button.edit')}>
                    <IconButton aria-label="Edit" onClick={this.handleEditClick.bind(this)}>
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                this.props.renderCreateButton
                  && (
                    <div />

                  )

              )

            }
          </div>
        </div>
      </Toolbar>
    );

  }

}

export default EnhancedTableToolbar;



// WEBPACK FOOTER //
// ./src/components/table/EnhancedTableToolbar.js